module.exports = __webpack_public_path__ + "img/block-t-2.26c293dc.jpg";